import { useEffect, useRef, useState } from 'react'
import styles from '@/components/directory/v2/DisplayComponent.module.css'
import SortingFilter from '@/components/filters/SortingFilter'
import CategoryManager from '@/components/directory/v2/CategoryManager'
import DisplayManager from '@/components/directory/v2/DisplayManager'

import { FaArrowRight, FaArrowLeft } from 'react-icons/fa'
import CountUp from 'react-countup'

const DisplayComponent = ({ onDisplayChange, results, currentPage, totalPages, onPageChange }) => {
  const [prevTotal, setPrevTotal] = useState(0)
  const [displayResults, setDisplayResults] = useState(0)
  const [isSticky, setIsSticky] = useState(false)
  const containerRef = useRef(null)

  useEffect(() => {
    const totalResults = results.reduce((acc, result) => acc + result.models.length, 0)
    setDisplayResults(totalResults)
  }, [results])

  useEffect(() => {
    const handleScroll = () => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect()
        const shouldBeSticky = rect.top <= 128
        setIsSticky(shouldBeSticky)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const handlePrevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1)
    }
  }

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1)
    }
  }

  return (
    <div ref={containerRef} className={`${styles.container} ${isSticky ? styles.sticky : ''}`}>
      <div className={styles.leftContent}>
        <div className={styles.results}>
          Results [<CountUp start={prevTotal} end={displayResults} duration={1.5} />]
        </div>
        <div className={styles.displayRow}>
          <CategoryManager results={results} />
        </div>
      </div>
      <div className={styles.rightContent}>
        <div className={styles.actions}>
          <div className={styles.paginationButtons}>
            {currentPage !== 1 && (
              <div className={styles.actionButton} onClick={handlePrevPage}>
                <FaArrowLeft />
              </div>
            )}
            {currentPage !== totalPages && (
              <div className={styles.actionButton} onClick={handleNextPage}>
                <FaArrowRight />
              </div>
            )}
          </div>
          <div className={styles.display}>
            <DisplayManager onDisplayChange={onDisplayChange} />
          </div>
        </div>
        <div className={styles.order}>
          <SortingFilter />
        </div>
      </div>
    </div>
  )
}

export default DisplayComponent
